export interface ReviewItem {
  readonly id: string;
  readonly author: string;
  readonly location: string;
  readonly date: string;
  readonly rating: number;
  readonly content: string;
}

export const reviewsData: readonly ReviewItem[] = [
  {
    id: 'daynurseries-review-1',
    author: 'M L (Mother of Child)',
    location: 'Romford, Essex',
    date: 'April 23rd, 2024',
    rating: 5,
    content: "Great Child Nursery has good management and friendly staff who from day one have supported our daughter settling, social, attitude has been amazing. She's always happy to go in and enjoys it. Thank you.",
  },
  {
    id: 'daynurseries-review-2',
    author: 'G O (Mother of Child)',
    location: 'Romford, Essex',
    date: 'April 2nd, 2024',
    rating: 5,
    content: "Overall experience at Great Child Nursery & Pre-School, Romford is excellent. Friendly staff and good learning activities/learning. Great value for money. A recommendation for room for improvement would be to look into refurbishing of outdoor space/facilities.",
  },
  {
    id: 'daynurseries-review-3',
    author: 'S B (Father of Child)',
    location: 'Romford, Essex',
    date: 'March 27th, 2024',
    rating: 5,
    content: "My daughter loves her school and she loves her teachers. She always talks about her teachers and how much she loves them. She enjoys the activities that they do in her school which include painting, drawing and so much more. Great Child is a very good nursery.",
  },
  {
    id: 'daynurseries-review-4',
    author: 'Victoria M (Mother of Child)',
    location: 'Romford, Essex',
    date: 'September 10th, 2019',
    rating: 5,
    content: "It took a while for my son to settle into nursery life. But with the support, understanding and patience from the staff and management team, my son really enjoys his time at the nursery now. He has come on leaps and bounds, learning something new every time he is at nursery, whether it’s new songs or ",
  },
  {
    id: 'daynurseries-review-5',
    author: ' A T (Mother of Child)',
    location: 'Romford, Essex',
    date: 'February 15th, 2019',
    rating: 5,
    content: "Great-Child Nursery is a fantastic nursery, very helpful, efficient, friendly, the most welcoming staff I have ever met. The management is awesome. My children absolutely love everything about the nursery and are always excited to go in for a great time. To top it up they open 7am - 7pm I really can’t ",
  },
] as const;
